<template>
  <div>
    <facit-header></facit-header>
      <div class = "profile-div col-12">
        <h5 class="mt-3 mb-3"> Network Architecture </h5>
        <br><br>
        <b-container class="bv-example-row">
          <b-row>
        <b-col sm="6">
          <img src="../assets/img/Multi-Site-Network-Topology.jpg" style="width:800px;" />
        </b-col>
      </b-row>
      </b-container>
      </div>
  </div>
</template>

<script>
import FacitHeader from '@/components/header';
import API from '@/api';

export default {
  name: 'Downloads',
  components: { FacitHeader },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      downloads: [],
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'version',
          label: 'Version',
          sortable: true,
        },
        {
          key: 'link',
          label: 'Downloads',
          sortable: false,
        },
      ],
    };
  },
  created() {
    this.getDownloads();
  },
  methods: {
    async getDownloads() {
      const downloads = await API.get('Downloads');
      this.downloads = downloads;
      this.totalRows = this.downloads.length;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon-width {
  width: 20px !important;
  height: 20px !important;
}
.profile-div {
  margin-top: 50px;
  margin-left: 50px;
  width: 95% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/architecture.vue